export default __webpack_public_path__ + "static/media/05_malina.e13dc261.jpg";